import * as THREE from "three";

export const OTHERS = [
  {
    name: "Metal009",
    listName: "OTHERS",
    texture: "./textures/others/metal009/Metal009_1K-PNG_Color.jpg",
    roughnessMap: "./textures/others/metal009/Metal009_1K-PNG_Roughness.jpg",
    normalMap: "./textures/others/metal009/Metal009_1K-PNG_NormalGL.jpg",
    metalnessMap: "./textures/others/metal009/Metal009_1K-PNG_Metalness.jpg",
    size: [1, 0.01, 1],
    offset: [0.0, 0.0],
    roughness: 1,
    metalness: 1,
    rotation: 1,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
    emissive: true,
  },
  {
    name: "Metal027",
    listName: "OTHERS",
    texture: "./textures/others/metal027/Color.jpg",
    roughnessMap: "./textures/others/metal027/Roughness.jpg",
    normalMap: "./textures/others/metal027/Normal.jpg",
    metalnessMap: "./textures/others/metal027/Metalness.jpg",
    size: [1, 0.05, 1],
    offset: [0.0, 0.0],
    roughness: 1,
    metalness: 1,
    rotation: 1,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
    emissive: true,
  },
];
